import axios from './api';
import axiosDefault from 'axios';

import { transformImageObject } from './utilities/helpers';

/**
 * create image object
 * @param {Object} options
 * @param {String} options.objectType
 * @return {Promise}
 */
export const createImageObject = async ({ objectType: object_type }) => {
  return axios({
    data: { object_type },
    method: 'post',
    url: '/instantsurvey/image',
  }).then(({ data }) => transformImageObject(data));
};

/**
 * upload image to S3 via presigned POST
 * @param {Object} options
 * @param {File} options.file
 * @param {Object} options.fields
 * @param {String} options.url
 * @return {Promise}
 */
export const uploadImageToS3 = async ({ fields, file, url }) => {
  const formData = new FormData();

  Object.entries(fields || {}).forEach(([key, value]) => {
    formData.append(key, value);
  });

  formData.append('file', file);

  return axiosDefault.post(url, formData);
};
